/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const Menu = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.Menu;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

Menu.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      Menu: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

Menu.defaultProps = {
  selectProps: {
    custom: {
      Menu: null,
    },
  },
  children: null,
};

export default Menu;
